import { createSlice } from "@reduxjs/toolkit";

export const setResultsSlice = createSlice({
    name: "setResults",
    initialState: {
        results: [],
        resultsForLayer: [],
        resultsForFeature: [],
        geocodingData: [],
        dataLinkData: {},
        relatedRecordsData: {},
    },
    reducers: {
        setGeocodingData: (state, action) => {
            state.geocodingData = action.payload;
            //const results = createResultsFromGeocode(action.payload);
            //state = setResultsState(state, results);
            //state.results = results;
        },
        setResultsData: (state, action) => {
            const newData = action.payload;
            state = setResultsState(state, newData);
            state.results = action.payload;
        },
        clearResults: (state) => {
            state.results = [];
            state.resultsForFeature = [];
            state.resultsForLayer = [];
            state.geocodingData = [];
        },
        setResultsForLayer: (state, action) => {
            state.resultsForLayer = action.payload;
        },
        setResultsForFeature: (state, action) => {
            state.resultsForFeature = action.payload;
        },
        removeLayer: (state, action) => {
            const newResults = state.results.filter((item) => item.Id !== action.payload);
            state.results = newResults;
            if (newResults.length < 2) {
                state.resultsForLayer = newResults;
            } else {
                state.resultsForLayer = [];
            }
        },
        // Remove feature by layer Id and by Feature Id
        removeFeature: (state, action) => {
            const layerId = action.payload.layerId;
            const featureId = action.payload.featureId;
            const newResultsForLayer = state.resultsForLayer[0].Features.filter(
                (item) => item !== featureId
            );
            const layerIndex = state.results.findIndex((item) => item.Id === layerId);

            state.resultsForFeature = [];
            state.results[layerIndex].Features = newResultsForLayer;

            if (newResultsForLayer.length === 0) {
                state.resultsForLayer = [];
                const newResults = state.results.filter((item) => item.Id !== layerId);
                state.results = newResults;
                if (newResults.length === 1) {
                    state.resultsForLayer = newResults;
                }
            } else {
                state.resultsForLayer[0].Features = newResultsForLayer;
            }
        },
        setDataLinkData: (state, action) => {
            const dataLinkData = action.payload;
            state.dataLinkData = dataLinkData;
        },
        setRelatedRecordData: (state, action) => {
            const relatedRecordsData = action.payload;
            state.relatedRecordsData = relatedRecordsData;
        },
    },
});

export const {
    setGeocodingData,
    setResultsData,
    removeFeature,
    removeLayer,
    clearResults,
    setResultsForFeature,
    setResultsForLayer,
    setDataLinkData,
    setRelatedRecordData,
} = setResultsSlice.actions;

export default setResultsSlice.reducer;

// Take in results data and populates state based on if:
//   all data is from one layer (or data type)
//                 OR
//   data is just one feature

const setResultsState = (state, newData) => {
    if (newData.length === 1 && newData[0].Features.length === 1) {
        state.resultsForFeature = newData;
        state.resultsForLayer = newData;
    } else if (newData.length === 1 && newData[0].Features.length > 1) {
        state.resultsForLayer = newData;
        state.resultsForFeature = [];
    } else {
        state.resultsForFeature = [];
        state.resultsForLayer = [];
    }
    return state;
};

// When geocode results are populated, calculate results
//   for the results pane
const createResultsFromGeocode = (geocodingData) => {
    const geoCodeResults = {
        DisplayName: "ArcGIS Geocoder",
        Id: "ArcGIS Geocoder",
        Features: [],
    };
    geocodingData.candidates.forEach((result) => {
        geoCodeResults.Features.push(result.attributes.Match_addr);
    });
    return [geoCodeResults];
};
